import { Image } from "@noom/wax-component-library";

import box from "image_assets/box-grey.svg";
import truck from "image_assets/truck-grey.svg";
import checkCircle from "image_assets/check-circle-grey.svg";
import resultsDocument from "image_assets/results-document.svg";

const ICON_BY_STATUS: Record<string, string> = {
  TreatmentOverviewStatusShippingSoon: box,
  TreatmentOverviewStatusShipped: truck,
  TreatmentOverviewStatusReplacementShipped: truck,
  TreatmentOverviewStatusCompletedKitShipped: truck,
  TreatmentOverviewStatusDelivered: checkCircle,
  TreatmentOverviewStatusCompletedKitReceived: checkCircle,
  TreatmentOverviewStatusResultsAvailable: resultsDocument,
};

type LabStatusIconProps = {
  status: string;
};

export const LabStatusIcon = ({ status }: LabStatusIconProps) => {
  const src = ICON_BY_STATUS[status];

  if (!src) {
    return null;
  }

  return <Image src={src} alt="" aria-hidden boxSize="16px" />;
};
